import { useEffect } from 'react';

const APP_TITLE = 'Contact Tel';

/**
 * Set the document title with a fixed app prefix.
 */
export function usePageTitle(pageTitle?: string, descriptor?: string) {
  useEffect(() => {
    const parts = [APP_TITLE];
    const normalizedTitle = pageTitle?.trim();
    if (normalizedTitle) {
      parts.push(normalizedTitle);
    }
    const normalizedDescriptor = descriptor?.trim();
    if (normalizedDescriptor) {
      parts.push(normalizedDescriptor);
    }
    document.title = parts.join(' | ');
  }, [pageTitle, descriptor]);
}

export default usePageTitle;
